import { getAuthData } from "../auth/session.js";
// Recovered from the preserved MetaCard production build.
// Behavior is retained; local names and TypeScript types were lost during minification.
import { IconChevronLeft, IconChevronRight, IconArrowRight, IconX } from "../../components/icons.jsx";
import { Yo } from "../../assets.jsx";
import { Xo } from "../../assets.jsx";
import { c_ } from "../../assets.jsx";
import { u_ } from "../../assets.jsx";
import { o_ } from "../../assets.jsx";
import { r_ } from "../../assets.jsx";
import { Qo } from "../../assets.jsx";
import { Zo } from "../../assets.jsx";
import { Vo } from "../../assets.jsx";
import { d_ } from "../../assets.jsx";
import { f_ } from "../../assets.jsx";
import { $o } from "../../assets.jsx";
import { Ko } from "../../assets.jsx";
import { h_ } from "../../assets.jsx";
import { m_ } from "../../assets.jsx";
import { hm } from "../../assets.jsx";
import { Jo } from "../../assets.jsx";
import { p_ } from "../../assets.jsx";
import { Ii } from "../../assets.jsx";
import { jn } from "../../assets.jsx";
import { Ns } from "../../assets.jsx";
import { Mo } from "../../assets.jsx";
import * as React from "react";
import * as jsxRuntime from "react/jsx-runtime";
import { i_ } from "../../assets.jsx";
import { CaseReel } from "./CaseReel.jsx";
import { CASE_SPIN_DURATION_MS, getReelWinnerIndex } from "./reel.js";
export { mm, pm, js } from "./reward-assets.js";
import { js } from "./reward-assets.js";
export const vm = [Xo, Zo, $o, Jo, Vo, Yo, Qo, Ko];
export const Vi = [{
  id: "free",
  title: "LIGHT",
  subtitle: "Лёгкий кейс с полезными ресурсами",
  price: "Бесплатно",
  image: Ii,
  balanceKey: "light"
}, {
  id: "standard",
  title: "LIMITED",
  subtitle: "Шанс получить лимитную карту",
  price: "100 MC",
  image: jn,
  balanceKey: "default"
}, {
  id: "rare",
  title: "MYSTIC",
  subtitle: "Редкие награды и Mystic карты",
  price: "250 MC",
  image: Ns,
  balanceKey: "hard"
}, {
  id: "season",
  title: "HALLOWEEN",
  subtitle: "Хэллоуинский кейс",
  price: "500 MC",
  image: Mo,
  balanceKey: "halloween"
}];
export const Ba = [["💎", "Кристаллы", "от 10"], ["🎴", "Крутки", "от 1"], ["🃏", "Редкая карта", "шанс 15%"], ["⚡", "Энергия", "от 5"], ["✨", "MetaCoin", "от 50"], ["🏆", "Очки рейтинга", "от 25"], ["🎁", "Бонусный кейс", "шанс 5%"], ["🌟", "Эпическая карта", "шанс 3%"], ["🃏", "LIMITED", "лимитная карта"], ["🌌", "Mystic", "мистическая карта"], ["🎨", "Theme", "тема профиля"]];
export const bm = {
  free: [{
    icon: "💎",
    title: "Кристаллы",
    label: "300 💎",
    chance: 30.86
  }, {
    icon: "💎",
    title: "Кристаллы",
    label: "1000 💎",
    chance: 18.52
  }, {
    icon: "💎",
    title: "Кристаллы",
    label: "5000 💎",
    chance: 3.7
  }, {
    icon: "🎴",
    title: "Крутки",
    label: "3 🎴",
    chance: 30.86
  }, {
    icon: "🎴",
    title: "Крутки",
    label: "10 🎴",
    chance: 12.35
  }, {
    icon: "🎴",
    title: "Крутки",
    label: "25 🎴",
    chance: 3.7
  }],
  standard: [{
    icon: "💎",
    title: "Кристаллы",
    label: "3000 💎",
    chance: 34.48
  }, {
    icon: "💎",
    title: "Кристаллы",
    label: "10000 💎",
    chance: 11.49
  }, {
    icon: "💎",
    title: "Кристаллы",
    label: "50000 💎",
    chance: 2.3
  }, {
    icon: "🎴",
    title: "Крутки",
    label: "10 🎴",
    chance: 34.48
  }, {
    icon: "🎴",
    title: "Крутки",
    label: "50 🎴",
    chance: 11.49
  }, {
    icon: "🎴",
    title: "Крутки",
    label: "100 🎴",
    chance: 3.45
  }, {
    icon: "🃏",
    title: "Лимитная карта",
    label: "LIMITED",
    chance: 2.3
  }],
  rare: [{
    icon: "💎",
    title: "Кристаллы",
    label: "7000 💎",
    chance: 26.67
  }, {
    icon: "💎",
    title: "Кристаллы",
    label: "10000 💎",
    chance: 13.33
  }, {
    icon: "💎",
    title: "Кристаллы",
    label: "50000 💎",
    chance: 4
  }, {
    icon: "💎",
    title: "Кристаллы",
    label: "150000 💎",
    chance: 1.33
  }, {
    icon: "🎴",
    title: "Крутки",
    label: "35 🎴",
    chance: 26.67
  }, {
    icon: "🎴",
    title: "Крутки",
    label: "50 🎴",
    chance: 13.33
  }, {
    icon: "🎴",
    title: "Крутки",
    label: "100 🎴",
    chance: 6.67
  }, {
    icon: "🎴",
    title: "Крутки",
    label: "250 🎴",
    chance: 4
  }, {
    icon: "🎴",
    title: "Крутки",
    label: "500 🎴",
    chance: 1.33
  }, {
    icon: "🌌",
    title: "Mystic карта",
    label: "Mystic",
    chance: 2.67
  }],
  season: [{
    icon: "💎",
    title: "Кристаллы",
    label: "3000 💎",
    chance: 22.67
  }, {
    icon: "💎",
    title: "Кристаллы",
    label: "10000 💎",
    chance: 9.07
  }, {
    icon: "💎",
    title: "Кристаллы",
    label: "25000 💎",
    chance: 2.72
  }, {
    icon: "💎",
    title: "Кристаллы",
    label: "50000 💎",
    chance: 1.81
  }, {
    icon: "💎",
    title: "Кристаллы",
    label: "250000 💎",
    chance: .09
  }, {
    icon: "🎴",
    title: "Крутки",
    label: "10 🎴",
    chance: 22.67
  }, {
    icon: "🎴",
    title: "Крутки",
    label: "25 🎴",
    chance: 9.07
  }, {
    icon: "🎴",
    title: "Крутки",
    label: "50 🎴",
    chance: 2.72
  }, {
    icon: "🎴",
    title: "Крутки",
    label: "100 🎴",
    chance: 1.81
  }, {
    icon: "🎴",
    title: "Крутки",
    label: "500 🎴",
    chance: .09
  }, {
    icon: "🐚",
    title: "Ракушки",
    label: "10 🐚",
    chance: 13.6
  }, {
    icon: "🐚",
    title: "Ракушки",
    label: "25 🐚",
    chance: 4.53
  }, {
    icon: "🐚",
    title: "Ракушки",
    label: "50 🐚",
    chance: 2.72
  }, {
    icon: "🐚",
    title: "Ракушки",
    label: "100 🐚",
    chance: 1.81
  }, {
    icon: "🐚",
    title: "Ракушки",
    label: "1000 🐚",
    chance: .09
  }, {
    icon: "🎨",
    title: "Тема профиля",
    label: "Theme",
    chance: 2.72
  }, {
    icon: "🃏",
    title: "Лимитная карта",
    label: "Лимитка",
    chance: 1.81
  }]
};
export const v_ = u => `${u.toLocaleString("ru-RU", {
  maximumFractionDigits: 2
})}%`;
export const b_ = {
  free: {
    "300 💎": "common",
    "1000 💎": "rare",
    "5000 💎": "epic",
    "3 🎴": "common",
    "10 🎴": "rare",
    "25 🎴": "epic"
  },
  standard: {
    "3000 💎": "common",
    "10000 💎": "rare",
    "50000 💎": "legendary",
    "10 🎴": "common",
    "50 🎴": "rare",
    "100 🎴": "epic"
  },
  rare: {
    "7000 💎": "common",
    "10000 💎": "rare",
    "50000 💎": "epic",
    "150000 💎": "legendary",
    "35 🎴": "common",
    "50 🎴": "rare",
    "100 🎴": "epic",
    "250 🎴": "legendary",
    "500 🎴": "mythic"
  },
  season: {
    "3000 💎": "common",
    "10000 💎": "rare",
    "25000 💎": "epic",
    "50000 💎": "legendary",
    "250000 💎": "mythic",
    "10 🎴": "common",
    "25 🎴": "rare",
    "50 🎴": "epic",
    "100 🎴": "legendary",
    "500 🎴": "mythic",
    "10 🐚": "common",
    "25 🐚": "rare",
    "50 🐚": "epic",
    "100 🐚": "legendary",
    "1000 🐚": "mythic"
  }
};
export const g_ = (u, o) => {
  const m = b_[u][o.label],
    r = o.label.endsWith("💎") ? "gems" : o.label.endsWith("🎴") ? "spins" : o.label.endsWith("🐚") ? "shells" : void 0;
  return js(r, m, o.label);
};
export function CasesPage({
  onBack: u,
  onSelect: o,
  recentDrops: m,
  onDrop: r,
  caseBalances: g,
  onCaseBalancesChange: j,
  onResourcesChange: B,
  onMetaCoinsChange: U
}) {
  const N = window.Telegram?.WebApp?.BackButton,
    openingRequest = React.useRef(false),
    [loading, setLoading] = React.useState(false),
    [winningIndexes, setWinningIndexes] = React.useState([]),
    [y, X] = React.useState(0),
    [M, R] = React.useState(1),
    [H, Y] = React.useState(!1),
    [P, W] = React.useState(!1),
    [ee, ie] = React.useState(bm.free),
    [w, I] = React.useState(null),
    [ne, oe] = React.useState([]),
    [le, te] = React.useState([]),
    Z = React.useRef(null),
    V = Vi[y],
    ae = g[V.balanceKey];
  React.useEffect(() => {
    if (N) return N.show(), N.onClick(u), () => {
      N.offClick(u), N.hide();
    };
  }, [u, N]), React.useEffect(() => {
    const L = bm[V.id];
    ie(L);
    const se = getAuthData();
    se && fetch("/api/cases/preview", {
      method: "POST",
      headers: {
        "Content-Type": "application/json"
      },
      body: JSON.stringify({
        initData: se,
        caseId: V.id
      })
    }).then(async C => {
      if (!C.ok) return;
      const f = await C.json();
      f.possibleRewards?.length && ie(f.possibleRewards);
    }).catch(() => {});
  }, [V.id]), React.useEffect(() => () => {
    Z.current !== null && window.clearTimeout(Z.current);
  }, []);
  const Te = L => X(se => (se + L + Vi.length) % Vi.length),
    je = () => {
      Z.current !== null && (window.clearTimeout(Z.current), Z.current = null), I("reward");
    },
    k = () => {
      Z.current !== null && (window.clearTimeout(Z.current), Z.current = null), I(null);
    },
    O = async () => {
      if (w || openingRequest.current) return;
      if (ae < M) {
        o(`Недостаточно кейсов: доступно ${ae}`);
        return;
      }
      const L = getAuthData();
      if (!L) {
        o("Открытие кейсов доступно внутри Telegram");
        return;
      }
      Z.current !== null && window.clearTimeout(Z.current);
      openingRequest.current = true;
      setLoading(true);
      const C = [];
      try {
        const h = await fetch("/api/cases/open", {
          method: "POST",
          headers: {
            "Content-Type": "application/json"
          },
          body: JSON.stringify({
            initData: L,
            caseId: V.id,
            amount: M
          })
        });
        if (!h.ok) {
          const F = await h.json().catch(() => ({
            error: "Не удалось открыть кейс"
          }));
          o(F.error || "Не удалось открыть кейс");
          return;
        }
        const p = await h.json(),
          G = p.rolls;
        if (!Array.isArray(G) || G.length !== M) throw new Error("Invalid case rolls");
        G.forEach(roll => getReelWinnerIndex(roll.reel.length, roll.winningIndex, G.length));
        if (j(p.cases), typeof p.metacoins == "number" && U(p.metacoins), p.resources && B(p.resources), G.length) {
          setWinningIndexes(G.map(roll => roll.winningIndex));
          te(G.map(ue => ue.reel.map(Me => ({
            icon: Me.icon,
            label: Me.label,
            rewardImage: js(Me.rewardType, Me.rarity, Me.label)
          }))));
          const ce = G.map(ue => ({
            icon: ue.winner.icon,
            title: ue.winner.displayTitle || ue.winner.title,
            label: ue.winner.label,
            rewardImage: js(ue.winner.rewardType, ue.winner.rarity, ue.winner.label)
          }));
          C.splice(0, C.length, ...ce), ce.forEach(ue => r({
            icon: ue.icon,
            caseImage: V.image,
            rewardImage: ue.rewardImage
          }));
        }
      } catch {
        o("Не удалось открыть кейс");
        return;
      } finally {
        openingRequest.current = false;
        setLoading(false);
      }
      if (oe(C), H) {
        I("reward");
        return;
      }
      I("spinning"), Z.current = window.setTimeout(je, CASE_SPIN_DURATION_MS);
    };
  return jsxRuntime.jsxs("section", {
    className: "mc-cases-page mc-cases-showcase",
    onClickCapture: L => {
      L.target.closest(".mc-case-open") && (L.preventDefault(), L.stopPropagation(), O());
    },
    children: [jsxRuntime.jsx("div", {
      className: "mc-last-drops",
      "aria-label": "Последние выпавшие награды",
      children: m.map((L, se) => jsxRuntime.jsxs("article", {
        children: [jsxRuntime.jsx("i", {
          children: jsxRuntime.jsx("img", {
            className: "mc-reward-image",
            src: L.rewardImage || vm[se % vm.length],
            alt: ""
          })
        }), jsxRuntime.jsx("img", {
          src: L.caseImage,
          alt: ""
        })]
      }, L.id))
    }), !N && jsxRuntime.jsxs("button", {
      className: "mc-wallet-back",
      onClick: u,
      children: [jsxRuntime.jsx("span", {
        children: jsxRuntime.jsx(IconChevronLeft, { "aria-hidden": "true" })
      }), " Назад"]
    }), jsxRuntime.jsxs("header", {
      children: [jsxRuntime.jsx("p", {
        children: "МЕТА КАРТЫ"
      }), jsxRuntime.jsx("h1", {
        children: "Кейсы"
      }), jsxRuntime.jsx("span", {
        children: "Выбирай кейсы и получай новые карты"
      })]
    }), jsxRuntime.jsxs("article", {
      className: `mc-case-stage ${V.id}`,
      children: [jsxRuntime.jsx("div", {
        className: "mc-case-stars",
        "aria-hidden": "true"
      }), jsxRuntime.jsx("button", {
        className: "mc-case-arrow prev mc-icon-button",
        "aria-label": "Предыдущий кейс",
        disabled: loading || Boolean(w),
        onClick: () => Te(-1),
        children: jsxRuntime.jsx(IconChevronLeft, { "aria-hidden": "true" })
      }), jsxRuntime.jsx("div", {
        className: "mc-case-object",
        "aria-hidden": "true",
        children: jsxRuntime.jsx("img", {
          src: V.image,
          alt: ""
        })
      }), jsxRuntime.jsx("button", {
        className: "mc-case-arrow next mc-icon-button",
        "aria-label": "Следующий кейс",
        disabled: loading || Boolean(w),
        onClick: () => Te(1),
        children: jsxRuntime.jsx(IconChevronRight, { "aria-hidden": "true" })
      }), jsxRuntime.jsx("button", {
        className: "mc-case-contents",
        "aria-label": "Показать возможные награды",
        onClick: () => W(!0),
        children: "?"
      }), jsxRuntime.jsxs("button", {
        className: `mc-case-instant mc-case-instant-stage ${H ? "active" : ""}`,
        "aria-label": "Быстрое открытие",
        disabled: loading || Boolean(w),
        onClick: () => Y(L => !L),
        children: [jsxRuntime.jsx("img", {
          src: i_,
          alt: ""
        }), jsxRuntime.jsx("span", {
          children: "Быстро"
        }), jsxRuntime.jsx("i", {
          children: H ? "✓" : ""
        })]
      })]
    }), jsxRuntime.jsx("div", {
      className: "mc-case-amounts",
      "aria-label": "Количество кейсов для открытия",
      children: [1, 3, 5].map(L => jsxRuntime.jsxs("button", {
        className: M === L ? "active" : "",
        disabled: loading || Boolean(w),
        onClick: () => R(L),
        children: ["×", L]
      }, L))
    }), jsxRuntime.jsx("div", {
      className: "mc-case-selector",
      "aria-label": "Выбор кейса",
      children: Vi.map((L, se) => jsxRuntime.jsxs("button", {
        className: se === y ? "active" : "",
        "aria-label": `${L.title}: ${g[L.balanceKey]}`,
        disabled: loading || Boolean(w),
        onClick: () => X(se),
        children: [jsxRuntime.jsx("i", {
          className: L.id,
          children: jsxRuntime.jsx("img", {
            src: L.image,
            alt: ""
          })
        }), jsxRuntime.jsxs("b", {
          children: ["×", g[L.balanceKey]]
        })]
      }, L.id))
    }), jsxRuntime.jsxs("button", {
      className: "mc-case-open",
      disabled: loading || Boolean(w) || ae < M,
      onClick: O,
      children: [loading ? "Открываем…" : ae < M ? "Недостаточно кейсов" : jsxRuntime.jsxs(jsxRuntime.Fragment, {
        children: ["Открыть ×", M]
      }), " ", jsxRuntime.jsx("span", {
        children: jsxRuntime.jsx(IconArrowRight, { "aria-hidden": "true" })
      })]
    }), P && jsxRuntime.jsxs("div", {
      className: "mc-case-rewards",
      role: "dialog",
      "aria-modal": "true",
      "aria-label": "Возможные призы",
      children: [jsxRuntime.jsx("button", {
        className: "mc-case-rewards-backdrop",
        "aria-label": "Закрыть",
        onClick: () => W(!1)
      }), jsxRuntime.jsxs("section", {
        children: [jsxRuntime.jsxs("header", {
          children: [jsxRuntime.jsxs("div", {
            children: [jsxRuntime.jsx("p", {
              children: "ВОЗМОЖНЫЕ НАГРАДЫ"
            }), jsxRuntime.jsx("h2", {
              children: "Что внутри"
            })]
          }), jsxRuntime.jsx("button", {
            className: "mc-icon-button",
            onClick: () => W(!1),
            "aria-label": "Закрыть",
            children: jsxRuntime.jsx(IconX, { "aria-hidden": "true" })
          })]
        }), jsxRuntime.jsx("div", {
          className: "mc-rewards-grid",
          children: ee.filter(L => L.chance > 0).map(L => {
            const se = g_(V.id, L) || js(L.rewardType, L.rarity, L.label);
            return jsxRuntime.jsxs("article", {
              children: [jsxRuntime.jsx("i", {
                children: se ? jsxRuntime.jsx("img", {
                  src: se,
                  alt: ""
                }) : L.icon
              }), jsxRuntime.jsx("b", {
                children: L.label
              }), jsxRuntime.jsx("small", {
                children: v_(L.chance)
              })]
            }, L.label);
          })
        })]
      })]
    }), w && jsxRuntime.jsx("div", {
      className: `mc-case-opening ${w} mc-opening-${V.id}`,
      onClick: () => w === "spinning" ? je() : k(),
      children: w === "spinning" ? jsxRuntime.jsxs("div", {
        className: "mc-case-reel-screen",
        children: [jsxRuntime.jsx("p", {
          children: "ОТКРЫВАЕМ КЕЙС"
        }), jsxRuntime.jsxs("div", {
          className: "mc-case-reel",
          children: [jsxRuntime.jsx("div", {
            children: [...Ba, ...Ba, ...Ba].map(([L, se, C], f) => jsxRuntime.jsxs("article", {
              children: [jsxRuntime.jsx("i", {
                children: L
              }), jsxRuntime.jsx("b", {
                children: se
              }), jsxRuntime.jsx("small", {
                children: C
              })]
            }, `${se}-${f}`))
          }), jsxRuntime.jsx("span", {})]
        }), jsxRuntime.jsx("small", {
          children: "Нажмите, чтобы пропустить"
        })]
      }) : ne.length > 0 && jsxRuntime.jsxs("div", {
        className: `mc-case-win ${ne.length > 1 ? "multiple" : ""}`,
        children: [jsxRuntime.jsx("div", {
          className: "mc-win-rays",
          "aria-hidden": "true"
        }), jsxRuntime.jsx("p", {
          children: ne.length > 1 ? "ВАШИ НАГРАДЫ" : "ВЫ ВЫИГРАЛИ!"
        }), jsxRuntime.jsx("div", {
          className: `mc-case-win-list mc-case-win-list-${ne.length}`,
          children: ne.map((L, se) => jsxRuntime.jsxs("article", {
            className: "mc-case-win-card",
            children: [jsxRuntime.jsx("i", {
              children: L.rewardImage ? jsxRuntime.jsx("img", {
                src: L.rewardImage,
                alt: ""
              }) : L.icon
            }), jsxRuntime.jsx("b", {
              children: L.label
            }), jsxRuntime.jsx("strong", {
              children: L.title
            })]
          }, `${L.label}-${se}`))
        }), jsxRuntime.jsx("small", {
          children: "Нажмите, чтобы продолжить"
        })]
      })
    }), w === "spinning" && jsxRuntime.jsxs("div", {
      className: `mc-live-reels mc-live-reels-${Math.max(M, 1)} mc-live-reels-${V.id}`,
      "aria-hidden": "true",
      children: [le.map((L, se) => jsxRuntime.jsx(CaseReel, {
        items: L,
        winningIndex: winningIndexes[se],
        amount: le.length
      }, se)), jsxRuntime.jsx("span", {
        className: "mc-live-reels-marker"
      })]
    })]
  });
}
